import moment from 'moment';
import { MONTHS, QUARTERS, YEARS } from '../constants/constants';

const createMonthsYearsArray = (dateType, format) => {
  let arr = [];
  for (let i = 0; i < 12; i++) {
    arr.push(moment().subtract(i, dateType).format(format));
  }
  return arr;
};

const createQuartersArray = () => {
  let arr = [];
  for (let i = 0; i < 12; i++) {
    arr.push(moment().subtract(i, 'Q').format('Y[Q]Q'));
  }
  return arr;
};

const createPeriod = (typePeriod) => {
  switch (typePeriod?.toUpperCase()) {
    case MONTHS:
      return createMonthsYearsArray('months', 'YYYY-MM');
    case QUARTERS:
      return createQuartersArray();
    case YEARS:
      return createMonthsYearsArray('years', 'YYYY');
    default:
      return createMonthsYearsArray('months', 'YYYY-MM');
  }
};

export default createPeriod;
